import { array, bool, element, node, number, func, string } from 'prop-types'
import { PureComponent, createRef } from 'react'
import { kuiperClassNames, isFunction } from '../../utils'
import './styles.scss'

class Cell extends PureComponent {
  static propTypes = {
    activateCell: func,
    active: bool,
    cellIndex: number,
    cellRefsByRow: array,
    children: node,
    className: string,
    focused: bool,
    leftSlot: element,
    onBlur: func,
    onClick: func,
    onFocus: func,
    rightSlot: element,
    rowIndex: number,
    tabbable: bool,
    width: number,
  }

  static defaultProps = {
    onBlur: () => {},
    onClick: () => {},
    onFocus: () => {},
  }

  constructor(props) {
    super(props)
    this.ref = createRef()
  }

  focus = () => {
    this.props.onFocus()
  }

  blur = (e) => {
    if (isFunction(this.props.onBlur) && this.cellActive) this.props.onBlur(e)
  }

  get leftSlot() {
    if (!this.props.leftSlot) return null

    return (
      <div className={kuiperClassNames('left-slot')}>{this.props.leftSlot}</div>
    )
  }

  get rightSlot() {
    if (!this.props.rightSlot) return null

    return (
      <div className={kuiperClassNames('right-slot')}>
        {this.props.rightSlot}
      </div>
    )
  }

  // Ensure our 2d array is initialized for this row
  initCellRefRow = () => {
    const { cellRefsByRow, rowIndex } = this.props
    if (!cellRefsByRow[rowIndex]) {
      cellRefsByRow[rowIndex] = []
    }
  }

  positionAndReturnRef = () => {
    const { cellRefsByRow, rowIndex, cellIndex, tabbable } = this.props

    if (!cellRefsByRow) return null

    this.initCellRefRow()

    cellRefsByRow[rowIndex][cellIndex] = { ref: this.ref, tabbable }

    return this.ref
  }

  activateCell = () => {
    const { activateCell, onClick } = this.props
    if (isFunction(activateCell)) activateCell()
    if (isFunction(onClick)) onClick()
  }

  get cellActive() {
    return this.props.active && this.props.focused
  }

  render() {
    const { children, className, width } = this.props

    return (
      <td
        className={kuiperClassNames(
          'cell',
          { active: this.cellActive },
          className
        )}
        ref={this.positionAndReturnRef()}
        onFocus={this.focus}
        onBlur={this.blur}
        onClick={this.activateCell}
        style={{ width }}
      >
        <div className={kuiperClassNames('content')} style={{ width }}>
          {this.leftSlot}
          <div className={kuiperClassNames('center-slot')}>{children}</div>
          {this.rightSlot}
        </div>
      </td>
    )
  }
}

export default Cell
